import { useState, useCallback } from 'react';
import useFetch from 'hooks/fetch';
import { muteAll, useFetchOld } from 'hooks';
import { useAppDispatch } from 'store/hooks';
import { getWatchlist, getWatchlists, createWatchlist, deleteWatchlist, updateWatchlist, } from '../actions';
const useWatchList = () => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [, , , deleteWatchListFetch] = useFetchOld(muteAll);
    const [, , , updateWatchListFetch] = useFetchOld(muteAll);
    const [, , , fetch] = useFetchOld(muteAll);
    const [fetchWatchLists] = useFetch();
    const [fetchWatchList] = useFetch();
    const getWatchLists = useCallback(async () => {
        try {
            const response = await fetchWatchLists(getWatchlists());
            const action = {
                type: 'GET_WATCHLISTS_SUCCESS',
                payload: {
                    watchlists: response.watchlists,
                },
            };
            dispatch(action);
        }
        catch {
            //
        }
    }, [fetchWatchLists]);
    const createWatchListFn = useCallback(async (name, emoji) => {
        setLoading(true);
        const response = await fetch(createWatchlist(name, emoji));
        setLoading(false);
        if (response?.watchlist) {
            return response?.watchlist;
        }
        return undefined;
    }, []);
    const deleteWatchListFn = useCallback(async (id) => {
        setLoading(true);
        await deleteWatchListFetch(deleteWatchlist(id));
        setLoading(false);
    }, [deleteWatchListFetch]);
    const updateWatchlistFn = useCallback(async (id, name, emoji) => {
        setLoading(true);
        const response = await updateWatchListFetch(updateWatchlist(id, { name, emoji }));
        setLoading(false);
        if (response?.watchlist) {
            return true;
        }
        return false;
    }, [updateWatchListFetch]);
    const getWatchListFn = useCallback(async (watchListId) => {
        try {
            setLoading(true);
            const response = await fetchWatchList(getWatchlist(watchListId));
            dispatch({
                type: 'GET_WATCHLIST_SUCCESS',
                payload: {
                    watchlist: response.watchlist,
                },
            });
            setLoading(false);
        }
        catch {
            //
        }
    }, [fetchWatchList]);
    return [loading, createWatchListFn, getWatchLists, deleteWatchListFn, updateWatchlistFn, getWatchListFn];
};
export default useWatchList;
